import styled from 'styled-components'

export const ConnectionOptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ $action, theme }) =>
    $action === 'Add' &&
    `
      padding: 15px 14px;

      &:hover {
        background-color: ${theme.colors.neutralW10};
        cursor: pointer;
      }
    `}
`

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.error70};
  font-size: 12px;
  margin-top: 5px;
`
